import React from 'react';
import { motion } from 'framer-motion';
import { FaLinkedin, FaChevronDown, FaDownload } from 'react-icons/fa';
import NetworkBackground from './NetworkBackground';

const Hero = () => {
  return (
    <section id="home" style={{ padding: 0, justifyContent: 'center', alignItems: 'center', height: '100vh', position: 'relative', overflow: 'hidden' }}>
      
      {/* Scientific Background Layer */}
      <NetworkBackground />
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1,
        background: 'radial-gradient(circle at 50% 50%, rgba(10, 15, 30, 0) 0%, rgba(10, 15, 30, 0.9) 100%)',
        pointerEvents: 'none'
      }} />
      <div className="vertical-scanline" style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '100px', zIndex: 2, pointerEvents: 'none', filter: 'drop-shadow(0 0 10px rgba(0, 240, 255, 0.9))' }}>
        <svg width="100%" height="100%" viewBox="0 0 1000 100" preserveAspectRatio="none">
          {/* Faint background track */}
          <path d="M0 50 L150 50 L170 30 L190 70 L210 10 L230 60 L250 50 L750 50 L770 20 L790 90 L810 10 L830 60 L850 50 L1000 50" stroke="rgba(0, 240, 255, 0.15)" strokeWidth="1.5" fill="none" />
          {/* Traveling bright pulse */}
          <path className="ecg-pulse" d="M0 50 L150 50 L170 30 L190 70 L210 10 L230 60 L250 50 L750 50 L770 20 L790 90 L810 10 L830 60 L850 50 L1000 50" stroke="#00f0ff" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      
      <div className="container" style={{ textAlign: 'center', zIndex: 10 }}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          <h2 style={{ fontSize: '1.5rem', color: 'var(--accent-cyan)', marginBottom: '1rem', fontWeight: 400, letterSpacing: '2px' }}>RAVI KISHAN AKULA</h2>
          <h1 style={{ fontSize: 'clamp(2.5rem, 6vw, 4.2rem)', lineHeight: 1.1, marginBottom: '1.5rem', textTransform: 'uppercase' }}>
            <span style={{ display: 'block' }}>Global Technology &</span>
            <span className="text-gradient">AI Innovation Leader</span>
          </h1>
          <p style={{ fontSize: '1.2rem', color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto 2.5rem auto', lineHeight: 1.6 }}>
            Visionary and execution-driven leader with 25+ years in IT (5+ in GenAI). Serving as a trusted C-level advisor, bridging robust AI strategy with rapid prototyping (POCs) and scalable, secure production delivery.
          </p>
          
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <motion.a 
              href="#contact"
              whileHover={{ scale: 1.05, boxShadow: '0 0 20px rgba(0, 240, 255, 0.4)' }}
              whileTap={{ scale: 0.95 }}
              style={{ padding: '12px 32px', borderRadius: '30px', background: 'var(--accent-gradient)', color: '#fff', fontWeight: 600, border: 'none' }}
            >
              Collaborate
            </motion.a>
            <motion.a 
              href="/Ravi_Kishan_Resume.pdf" target="_blank" download="Ravi_Kishan_Resume.pdf"
              whileHover={{ scale: 1.05, background: 'rgba(0,240,255,0.1)' }}
              whileTap={{ scale: 0.95 }}
              style={{ padding: '12px 24px', borderRadius: '30px', display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--accent-cyan)', background: 'transparent', border: '1px solid var(--accent-cyan)', fontWeight: 600 }}
            >
              <FaDownload size={16} /> Resume
            </motion.a>
            <motion.a 
              href="https://www.linkedin.com/in/aravikishan/" target="_blank" rel="noreferrer"
              whileHover={{ scale: 1.05, background: 'rgba(255,255,255,0.1)' }}
              whileTap={{ scale: 0.95 }}
              className="glass-panel"
              style={{ padding: '12px 20px', borderRadius: '30px', display: 'flex', alignItems: 'center', gap: '8px', color: '#fff', border: '1px solid var(--glass-border)' }}
            >
              <FaLinkedin size={20} /> LinkedIn
            </motion.a>
          </div>
        </motion.div>
      </div>

      <motion.div 
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 2, ease: 'easeInOut' }}
        style={{ position: 'absolute', bottom: '40px', left: '50%', transform: 'translateX(-50%)', color: 'var(--text-secondary)' }}
      >
        <FaChevronDown size={24} />
      </motion.div>
    </section>
  );
};

export default Hero;
